<template>
  <div>
    <div v-if="loading">
      <vue-element-loading :active="true" :is-full-screen="true" />
    </div>
    <CModal title="Add Bonus" :show.sync="isModal">
      <template #header>
        <h6 class="modal-title">Prize Distribution</h6>
        <CButtonClose @click="isModal = false" />
      </template>
      <CCol col="12" md="12">
        <table class="table1">
          <tr>
            <th>Rank</th>
            <th>Prize</th>
          </tr>
          <tr v-for="(item, index) in winningPercentage" :key="item">
            <td>{{ index + 1 }}</td>
            <td>{{ item }}</td>
          </tr>
        </table>
      </CCol>

      <template #footer>
        <span></span>
        <!-- <CButton color="success">Save</CButton> -->
      </template>
    </CModal>
    <CCard v-if="!loading">
      <CCardHeader>
        <h5>
          <b>Amount distribution</b>
        </h5>
      </CCardHeader>
      <CRow>
        <!-- <CCol sm="3" class="m-3">
          <input
            type="number"
            class="form-control"
            placeholder="Enter the Esports ID"
            v-model.number="gameId"
          />
        </CCol> -->
        <CCol sm="3" class="m-3">
          <CButton @click="isModal = true" class="px-3" color="success"
            >Show Prize Distribution
          </CButton>
        </CCol>
      </CRow>

      <CCardBody>
        <CDataTable
          :items="tableData"
          :fields="fields"
          column-filter
          table-filter
          items-per-page-select
          :items-per-page="10"
          hover
          sorter
          pagination
          responsive
        >
          <template #prize="{ item }">
            <td>
              <input
                type="number"
                class="form-control"
                placeholder="Enter Prize"
                v-model.number="item.prize"
              />
            </td>
          </template>
        </CDataTable>
      </CCardBody>
      <CCardFooter class="text-center my-3">
        <CButton
          class="px-3"
          color="success"
          :disabled="!tableData.length > 0"
          @click="saveChanges()"
          >Save Changes</CButton
        >
      </CCardFooter>
    </CCard>
  </div>
</template>
    <script>
import firebase from "firebase";
const db = firebase.firestore();
import VueElementLoading from "vue-element-loading";

import moment from "moment";
import Swal from "sweetalert2";
import axios from "axios";

import JsonCSV from "vue-json-csv";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
export default {
  name: "EsportsDistribution",
  components: {
    JsonCSV,
    DatePicker,
    VueElementLoading,
  },
  data() {
    return {
      value1: [],
      tableData: [],
      gameId: null,
      loading: false,
      winningPercentage: [],
      isModal: false,
      fields: [
        {
          label: "email",
          key: "email",
          sortable: true,
        },
        {
          label: "Play Cost",
          key: "playCost",
          sortable: true,
        },
        {
          label: "Game Name",
          key: "gameName",
          sortable: true,
        },
        // {
        //   label: "Tournament ID",
        //   key: "tournamentId",
        //   sortable: true,
        // },
        {
          label: "Esports ID",
          key: "esportsID",
          sortable: true,
        },
        {
          label: "Game User Id",
          key: "gameUserId",
          sortable: true,
        },
        {
          label: "Game User Name",
          key: "gameUserName",
          sortable: true,
        },
        {
          label: "Action",
          key: "prize",
          sortable: true,
        },
      ],
    };
  },

  methods: {
    showMessage(msg, icon) {
      Swal.fire({
        position: "center",
        icon: icon,
        title: msg,
        showConfirmButton: false,
        timer: 3000,
      });
    },
    async saveChanges() {
      this.tableData.forEach((e) => {});
      if (this.tableData.some((e) => e.prize === "")) {
        this.showMessage("Some Prize Fields are Missing ", "warning");
      } else {
        this.loading = true;
        try {
          const resp = await axios.post(
            "https://scramble-api.rage.fan/esportsSettlement",
            { settlement: this.tableData }
          );
          this.loading = false;
          if (resp.data.status == true) {
            this.showMessage("Prize Updated Successfully", "success");
            this.$router.push({
              name: "esportsList",
            });

            //   this.$router.push({ name: "tournaments" });
          } else {
            this.showMessage("Couldn't update Prize ", "error");

            //   this.$router.push({ name: "tournaments" });
          }
        } catch (error) {
          this.loading = false;
        }
        //localhost:5000/token-geomine/us-central1/api
        // this.showMessage("SuccessFully Saved ", "success");
      }
    },
    getByGameId() {
      try {
        // if (this.gameId == null || this.gameId == "")
        //   return this.showMessage("Enter a valid Esports Id ", "warning");
        this.loading = true;
        db.collection("HTMLGamesPointsEntry")
          .where("esportsID", "==", parseInt(this.gameId))
          .get()
          .then((snapshot) => {
            this.tableData = [];

            snapshot.forEach((doc) => {
              this.tableData.push({
                id: doc.id,
                email: doc.data().email,
                playCost: doc.data().playCost,
                gameName: doc.data().gameName,
                esportsID: doc.data().esportsID,
                gameUserId: doc.data().gameUserId,
                gameUserName: doc.data().gameUserName,
                tournamentDocId: doc.data().tournamentDocId,
                prize: "",
              });
            });
            this.loading = false;
          })
          .catch((e) => {
            this.loading = false;
          });
      } catch (error) {
        this.loading = false;
      }
    },
    getGames() {
      var res = new Date();
      res.setDate(res.getDate() - 2);

      let v1 = firebase.firestore.Timestamp.fromDate(new Date());
      let v2 = firebase.firestore.Timestamp.fromDate(new Date(res));

      db.collection("esportsTournament")
        .where("isContestEnabled", "==", true)
        .where("created", ">=", v2)
        .where("created", "<=", v1)
        .get()
        .then((snapshot) => {
          this.tableData = [];
          var i = 0;
          var dateNow = new Date();
          snapshot.forEach((doc) => {
            this.tableData.push({
              id: doc.id,
              name: doc.data().gameName,
              icon: doc.data().gameImage,
              matchStatus: doc.data().matchStatus,
              tournamentName: doc.data().tournamentName,
              winners: doc.data().winnersList ? doc.data().winnersList : [],
            });
          });
        })
        .catch((e) => {});
    },
  },
  created() {
    this.gameId = this.$route.params.id;
    this.winningPercentage = this.$route.params.winningPercentage;
    this.getByGameId();
    // this.getGames();
  },
};
</script>

<style>
.table1 {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

.table1 td,
.table1 th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}
</style>